/// <amd-module name="SuiteCommerce.ProductLeadTime.PDP.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ProductLeadTime.PDP.Model", ["require", "exports", "Backbone", "SuiteCommerce.ProductLeadTime.Instrumentation", "bignumber", "SuiteCommerce.ProductLeadTime.PDP.Configuration"], function (require, exports, Backbone_1, Instrumentation_1, BigNumber, PDP_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var script = {
        id: 'customscript_ns_sc_sl_productleadtime',
        deploymentId: 'customdeploy_ns_sc_sl_productleadtime',
    };
    var PDPModel = /** @class */ (function (_super) {
        __extends(PDPModel, _super);
        function PDPModel() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.urlRoot = "/app/site/hosting/scriptlet.nl?script=" + script.id + "&deploy=" + script.deploymentId;
            return _this;
        }
        Object.defineProperty(PDPModel.prototype, "leadTime", {
            get: function () {
                if (this.isLeadTimeAboveThreshold()) {
                    return this.leadTimeThreshold;
                }
                return this.get('leadTime');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "purchaseOrder", {
            get: function () {
                if (this.isLeadTimeAboveThreshold()) {
                    return 0;
                }
                return this.get('purchaseOrder');
            },
            enumerable: true,
            configurable: true
        });
        PDPModel.prototype.isLeadTimeAboveThreshold = function () {
            return (this.leadTimeThreshold &&
                this.leadTimeThreshold > 0 &&
                this.leadTimeThreshold < this.get('leadTime') + this.get('purchaseOrder'));
        };
        Object.defineProperty(PDPModel.prototype, "item", {
            get: function () {
                return this.get('item');
            },
            set: function (item) {
                this.set('item', item);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "totalDays", {
            get: function () {
                return this.get('totalDays');
            },
            set: function (totalDays) {
                this.set('totalDays', totalDays);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "leadTimeDate", {
            get: function () {
                return this.get('leadTimeDate');
            },
            set: function (leadTimeDate) {
                this.set('leadTimeDate', leadTimeDate);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "showLeadTime", {
            get: function () {
                return this.get('showLeadTime');
            },
            set: function (showLeadTime) {
                this.set('showLeadTime', showLeadTime);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "productLeadMessage", {
            get: function () {
                return this.get('productLeadMessage');
            },
            set: function (productLeadMessage) {
                this.set('productLeadMessage', productLeadMessage);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PDPModel.prototype, "leadTimeThreshold", {
            get: function () {
                var threshold = this.get('leadTimeThreshold');
                return threshold && threshold > 0 ? threshold : PDP_Configuration_1.PDPConfiguration.leadTimeThreshold;
            },
            enumerable: true,
            configurable: true
        });
        PDPModel.prototype.fetchLeadTime = function () {
            var _this = this;
            var fetchLeadTimeLog = Instrumentation_1.default.getLog('fetchLeadTime');
            fetchLeadTimeLog.startTimer();
            var deferred = jQuery.Deferred();
            this.fetch({
                data: { itemid: this.item.internalid },
            }).done(function () {
                fetchLeadTimeLog.endTimer();
                _this.logFetchLeadTime(fetchLeadTimeLog);
                _this.totalDays = new BigNumber(_this.leadTime).plus(_this.purchaseOrder).toNumber();
                deferred.resolve();
            });
            return deferred.promise();
        };
        PDPModel.prototype.logFetchLeadTime = function (log) {
            log.setParameters({
                activity: 'Fetch Timer',
                totalTime: log.getElapsedTimeForTimer(),
            });
            log.submit();
        };
        PDPModel.prototype.fetchLeadTimeDate = function () {
            var _this = this;
            var deferred = jQuery.Deferred();
            this.fetchLeadTime().done(function () {
                _this.leadTimeDate =
                    _this.totalDays <= 0 ? _this.calculateDate(0) : _this.calculateDate(_this.totalDays);
                deferred.resolve();
            });
            return deferred.promise();
        };
        PDPModel.prototype.calculateDate = function (totalDays) {
            var date = new Date();
            return date.setTime(date.getTime() + totalDays * 24 * 60 * 60 * 1000);
        };
        PDPModel.prototype.itemRequiresLeadTimeMessage = function () {
            return this.item.custitem_ns_sc_ext_plt_leadtimemessage && !this.item.isinstock;
        };
        return PDPModel;
    }(Backbone_1.Model));
    exports.PDPModel = PDPModel;
});
